var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 auto","width":"300px"}},[_c('img',{staticStyle:{"width":"300px","height":"300px"},attrs:{"src":require("../../../assets/OnBoardingQRCode.png")}}),_vm._v(" "),_c('Button',{staticStyle:{"margin-left":"90px"},on:{"click":_vm.jumpPage}},[_vm._v("填写入职信息")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61adb4d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/MyManagement/OnBoardingQRCode.vue
// module id = null
// module chunks = 